export function NonSelectableView({ children }) {
    return <div className="noselect">
        {children}
    </div>;
}